import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabaseEnabled = Boolean(url && key && !url.includes('YOUR-PROJECT'));

export const supabase = supabaseEnabled
  ? createClient(url, key, { auth: { persistSession: true, autoRefreshToken: true } })
  : (null as any);

export type DBBook = {
  id: string;
  user_id: string;
  title: string;
  author: string | null;
  file_hash: string;
  pages: number;
  chapters: number;
  cover_kind: string;
  metadata: Record<string, unknown> | null;
  created_at: string;
};

export type DBProgress = {
  user_id: string;
  book_id: string;
  chapter: number;
  page: number;
  position: number;
  updated_at: string;
};

export type DBHighlight = {
  id: string;
  user_id: string;
  book_id: string;
  chapter: number;
  page: number;
  text: string;
  note: string | null;
  kind: 'quote' | 'learning';
  status: 'pending' | 'synced';
  created_at: string;
};
